import React from 'react'
import { Card, Image, Tag } from 'antd-mobile'
import { YenSpan } from '../common/YenSpan'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ProductCard extends React.PureComponent {
  static defaultProps = {
    name: '-',
    currentPrice: '-',
    imgSrc: null
  }
  onClick = () => {
    this.props.onClick(this.props.id)
  }

  render () {
    // const {
    //   title, imgSrc, price
    // } = this.props
    const {
      name,
      // id,
      catalog,
      productId,
      productPic: imgSrc,
      currentPrice
      // stock
    } = this.props
    return <Card key={productId} full onClick={this.onClick}>
      <Image src={imgSrc}/>
      <div>
        <div className='line-clamp-2 leading-normal py-2'>{name}</div>
        <div className='leading-loose'>
          <YenSpan
            smallSymbol
            color
            className='text-lg'>{currentPrice}</YenSpan>
          &nbsp;
          <Tag fill='outline' color='#888'>{catalog['name']}</Tag>
        </div>
      </div>
    </Card>
  }
}

export { ProductCard }
